module.exports = __webpack_public_path__ + "static/media/coinfield_black_logo.7571efca.png";